import _slicedToArray from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallbackRef as e } from "@radix-ui/react-use-callback-ref";
import * as t from "react";
export function useControllableState(_ref) {
  var o = _ref.prop,
      r = _ref.defaultProp,
      _ref$onChange = _ref.onChange,
      n = _ref$onChange === void 0 ? function () {} : _ref$onChange;

  var _ref2 = function (_ref4) {
    var o = _ref4.defaultProp,
        r = _ref4.onChange;

    var n = t.useState(o),
        _n = _slicedToArray(n, 1),
        a = _n[0],
        u = t.useRef(a),
        c = e(r);

    return t.useEffect(function () {
      u.current !== a && (c(a), u.current = a);
    }, [a, u, c]), n;
  }({
    defaultProp: r,
    onChange: n
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      a = _ref3[0],
      u = _ref3[1],
      c = void 0 !== o,
      f = c ? o : a,
      l = e(n);

  return [f, t.useCallback(function (e) {
    if (c) {
      var _t = e,
          _r = "function" == typeof e ? _t(o) : e;

      _r !== o && l(_r);
    } else u(e);
  }, [c, o, u, l])];
}